<article>
  <section>
    <div class="products-container">
      <app-products 
        #productComponent 
        *ngIf="products.length" 
        [products]="products" 
        [selectedProductIds]="selectedProductIds"
        (productSelected)="onProductSelected($event)">
      </app-products>
    </div>
    <app-subtitles #subtitles></app-subtitles>
    <div class="action-buttons" *ngIf="products.length">
      <button (click)="continueToCart()" class="continue-btn" *ngIf="selectedProductIds.size > 0">
        Continuar ({{ selectedProductIds.size }})
      </button>
      <button (click)="noInterest()" class="noInterest">No me interesa</button>
    </div>
  </section>
  <footer>
    <app-speech #speechComponent [actionButton]="actionButtonState"></app-speech>
  </footer>
</article>
